<template>
  <div v-if="!prdEnv()" class="mb-4">

    <!--#region -- Content ---->
    <!--#region SFDC Synchronization Real Data-->
    <div class="">
      <div class="caption-label d-flex" v-if="sfdcProducts">
        <div>
          <b-badge style="margin-right: 10px;" v-if="sfdcProducts" variant="primary">{{sfdcProducts.length}}</b-badge>
          FTIE X GenAI
        </div>
      </div>

      <div v-if="!prdEnv()">
        <div class="header-col-free-no-dot flex-wrap">
          <div style="font-weight: bold;">GenAI Module</div>

          <b-form-select v-model="selectedGai" class="mb-3"
                         :options="gaiOptions"
                         disabled-field="notEnabled">
          </b-form-select>

        </div>
        <!-- region: openAI direct-->
        <div v-if="selectedGai === 'gpt-3.5-turbo' || selectedGai === 'BreeXe-8x7B'">
          <div class="header-col-free-no-dot flex-wrap">
            <div style="font-weight: bold;">Message to GenAI</div>
            <b-form-textarea class="w-100"
                             v-model="inputText"></b-form-textarea>
            <button style="margin-top: 0.2rem; margin-left: 1025px;" type="button"
                    class="btn btn-sm btn-primary"
                    @click="showPromptResult(selectedGai, inputText, 'free_question', inputText, false)">
              Send
            </button>
          </div>

          <div v-if="hideOpenAiService !== true">
            <div class="header-col-free-no-dot flex-wrap">
              <div style="font-weight: bold;">
                GenAI is here to help you
                <button style="margin-top: -0.2rem;" type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                        v-b-tooltip.hover.bottom
                        title="Choose the purpose you seek ChatGPT for help"></button>
              </div>
              <b-list-group style="width:700px">

                <b-list-group-item :active="chosenPrompt === 'hidden_meaning'" button
                                   @click="showPromptResult(selectedGai, inputText, 'hidden_meaning', null, false)">
                  Learn more about this issue
                </b-list-group-item>
                <b-list-group-item button>
                  Translate to
                  <b-badge v-if="chosenPrompt === 'translate' && chatGptOutput !== '' && chatGptOutput !== null"
                           variant="primary" pill>1</b-badge>
                  <b-form-group v-slot="{ ariaDescribedby }">
                    <b-form-radio-group id="radio-group-1"
                                        v-model="selectedLanguage"
                                        :options="languageOptions"
                                        :aria-describedby="ariaDescribedby"
                                        name="radio-options">
                      <b-link href="#" @click="showPromptResult(selectedGai, inputText, 'translate', selectedLanguage, false)">Translate Now!</b-link>
                    </b-form-radio-group>
                  </b-form-group>

                </b-list-group-item>
                <b-list-group-item :active="chosenPrompt === 'reply'" button @click="showPromptResult(selectedGai, inputText, 'reply', null, false)">How to reply</b-list-group-item>
                <b-list-group-item button
                                   :disabled="!enableManualType">
                  I have other question to ask
                  <b-form-checkbox v-model="enableManualType"
                                   name="check-button"
                                   @change="cleanChatGPTPromptInput() && disableManualType('follow-up')"
                                   switch>
                    Switch to <span v-if="enableManualType"><b>deactivate</b></span>
                    <span v-else><b>activate</b></span>
                  </b-form-checkbox>
                </b-list-group-item>
              </b-list-group>
            </div>
          </div>

        </div>
        <!-- endregion -->
        <!-- region: LangChain-->
        <div v-else-if="hideOpenAiService !== true && (selectedGai === 'lc-gpt-3.5-turbo' || selectedGai === 'lc-gpt-4o')">
          <div>
            <div class="header-col-free-no-dot flex-wrap">
              <div style="font-weight: bold;">Tasks</div>

              <b-form-select v-model="selectedLangChainTask" class="mb-3"
                             :options="langChainTaskOptions">
              </b-form-select>

            </div>

            <div v-if="selectedLangChainTask === 'lc_summarize_web' || selectedLangChainTask === 'lc_summarize_text'"
                 class="header-col-free-no-dot flex-wrap">
              <div v-if="selectedLangChainTask === 'lc_summarize_web'" style="font-weight: bold;">Website</div>
              <div v-else style="font-weight: bold;">Text</div>
              <b-form-textarea class="w-100"
                               v-model="inputText"></b-form-textarea>
              <button style="margin-top: 0.2rem; margin-left: 1025px;" type="button"
                      class="btn btn-sm btn-primary"
                      @click="showPromptResult(selectedGai, inputText, selectedLangChainTask, inputText, false)">
                Send
              </button>
            </div>


          </div>
          <div>

          </div>
        </div>
        <!-- endrigion -->
        <!-- region: Getac H100 AI on-premise -->
        <div v-else-if="hideOpenAiService === true">
          <div>
            <!--
              <div class="header-col-free-no-dot flex-wrap">
                <div style="font-weight: bold;">Tasks</div>

                <b-form-select v-model="selectedLangChainTask" class="mb-3"
                               :options="langChainTaskOptions">
                </b-form-select>

              </div>

              -->


            <div class="header-col-free-no-dot flex-wrap">
              <div style="font-weight: bold;">Message to Getac On-Premise AI</div>
              <b-form-textarea class="w-100"
                               v-model="inputText"></b-form-textarea>
              <button style="margin-top: 0.2rem; margin-left: 1025px;" type="button"
                      class="btn btn-sm btn-primary"
                      @click="showPromptResult(selectedGai, inputText, 'free_question', inputText, false)">
                Send
              </button>
            </div>



          </div>
          <div>

          </div>
        </div>
        <!-- endrigion -->



        <div v-if="enableManualType" class="header-col-free-no-dot flex-wrap">
          <div class="text-nowrap" style="font-weight: bold;">My Question</div>
          <b-form-textarea class="w-100"
                           v-model="questionForChatGPT"></b-form-textarea>
          <button style="margin-top: 0.2rem; margin-left: 1025px;" type="button"
                  class="btn btn-sm btn-link"
                  @click="showPromptResult(selectedGai, questionForChatGPT, 'free_question', inputText, false)">
            <img style="width:35px;"
                 src="../../../static/image/message-send-svgrepo-com.svg" alt="Msg Send" />
          </button>
        </div>
        <div class="border-bottom" style="padding-top: 0.5rem;"></div>

        <div class="header-col-free-no-dot">
          <!--
                    <div>
                      <img style="width:30px;"
                           src="../../../static/image/ChatGPT_logo.svg" />
                    </div>
          -->

          <div>
            <img style="width: 60px;" src="../../../static/image/logo_Getac_old.svg" alt="Getac Logo" />
            <b-icon icon="chat-dots-fill"></b-icon>
          </div>
          <div v-if="paperOutput !== '' && paperOutput !== null">
            <p class="my-4" style="color:gray" v-html="safeHtml(paperOutput)"></p>
          </div>
          <div v-else-if="paperOutput === '' && chatGptOutput !== '' && chatGptOutput !== null">
            <p class="my-4" style="color:gray" v-html="safeHtml(chatGptOutput)"></p>
            <div v-if="(chatGptPreviousOutput === '' || chatGptPreviousOutput === null) && (chosenPrompt === 'hidden_meaning' || chosenPrompt === 'reply' ||
                         chosenPrompt === 'free_question') &&
                         chatGptOutput !== '' &&
                         chatGptOutput !== null">
              <small>
                <b-form-checkbox style="margin-top: -18px;"
                                 v-model="storeConversation"
                                 name="check-button"
                                 @change="disableManualType('')" switch>
                  Switch to <span v-if="storeConversation"><b>close </b>conversation</span>
                  <span v-else><b>keep </b>conversation</span>
                </b-form-checkbox>
              </small>
            </div>
          </div>
          <div v-else>
            <p class="my-4" style="color:gray" v-html="safeHtml(paper)"></p>
          </div>
        </div>
        <div v-if="storeConversation && (chosenPrompt === 'hidden_meaning' || chosenPrompt === 'reply' || chosenPrompt === 'free_question') && chatGptOutput !== '' && chatGptOutput !== null"
             class="border-bottom" style="padding-top: 0.5rem;">
        </div>

        <div v-if="storeConversation && (chatGptPreviousOutput === '' || chatGptPreviousOutput === null)
                     && (chosenPrompt === 'hidden_meaning'
                     || chosenPrompt === 'reply' || chosenPrompt === 'free_question')
                     && chatGptOutput !== '' && chatGptOutput !== null"
             class="header-col-free-no-dot flex-wrap">
          <div class="text-nowrap" style="font-weight: bold;">Follow-up Question</div>
          <b-form-textarea class="w-100"
                           v-model="followUpQuestionForChatGPT"></b-form-textarea>
          <button style="margin-top: 0.2rem; margin-left: 1025px;" type="button"
                  class="btn btn-sm btn-link"
                  @click="showPromptResult(selectedGai, followUpQuestionForChatGPT, chosenPrompt, [inputText, chatGptOutput], true)">
            <img style="width:35px;"
                 src="../../../static/image/message-send-svgrepo-com.svg" alt="Msg Send" />
          </button>
        </div>

        <div v-if="chatGptPreviousOutput !== '' && chatGptPreviousOutput !== null"
             class="header-col-free-no-dot flex-wrap">
          <div style="font-weight: bold;">Follow-up Question</div>
          <b-form-textarea class="w-100"
                           id="textarea-plaintext"
                           plaintext
                           style="padding-left: 36px;"
                           :value="followUpQuestionForChatGPT"></b-form-textarea>
        </div>

        <div v-if=" chatGptPreviousOutput !== '' && chatGptPreviousOutput !== null"
             class="header-col-free-no-dot">
          <!--
                    <div>
                      <img style="width:30px;"
                           src="../../../static/image/ChatGPT_logo.svg" />
                    </div>
          -->
          <div>
            <img style="width: 60px;" src="../../../static/image/logo_Getac_old.svg" alt="Getac Logo" />
            <b-icon icon="chat-dots-fill"></b-icon>
          </div>

          <p class="my-4" style="color:gray" v-html="safeHtml(chatGptPreviousOutput)"></p>
        </div>

        <!--
                        <template #modal-footer>
                    <div class="w-100">
                      <b-button variant="secondary"
                                size="sm"
                                class="float-right"
                                @click="closePromptResult(row.item.subject_id)">
                        Copy the reply
                      </b-button>
                      <p class="float-left"
                         style="color: lightgray; font-style: italic; padding-left: 839px">* The copy reply function is not enabled yet</p>

                    </div>
                  </template>

        -->


      </div>
      <!--#endregion-->
      <!-- #endregion Modal-->
    </div>
  </div>
  <div v-else class="coming-soon-page">
    <div class="coming-soon-card">

      <!-- Animated icon -->
      <div class="cs-icon-area">
        <div class="cs-icon-ring">
          <i class="fa fa-cogs cs-cog-icon"></i>
        </div>
        <div class="cs-steam-row">
          <span class="cs-steam"></span>
          <span class="cs-steam"></span>
          <span class="cs-steam"></span>
        </div>
      </div>

      <!-- Brand badge -->
      <div class="cs-brand-badge">
        <img src="https://www.getac.com/img/getac-logo.png"
             alt="Getac"
             class="cs-brand-logo"
             onerror="this.style.display='none'" />
        <span class="cs-brand-text">Getac On-Premise AI · Genova</span>
      </div>

      <!-- Heading -->
      <h1 class="cs-title">We're Cooking Something Great</h1>
      <p class="cs-subtitle">
        This feature is currently under active development and not yet available in this environment.<br />
        Our engineering team is working hard to bring you a powerful AI-enhanced experience.
      </p>

      <!-- Progress bar -->
      <div class="cs-progress-wrap">
        <div class="cs-progress-label d-flex justify-content-between mb-1">
          <span><i class="fa fa-code mr-1"></i>Development in progress</span>
          <span class="cs-progress-pct">In Dev</span>
        </div>
        <div class="cs-progress-track">
          <div class="cs-progress-bar"></div>
        </div>
      </div>

      <!-- Info chips -->
      <div class="cs-chips">
        <span class="cs-chip cs-chip-orange"><i class="fa fa-bolt mr-1"></i>AI Enhanced</span>
        <span class="cs-chip cs-chip-blue"><i class="fa fa-lock mr-1"></i>Pre-Production</span>
        <span class="cs-chip cs-chip-gray"><i class="fa fa-clock-o mr-1"></i>Launching Soon</span>
      </div>

    </div>
  </div>
</template>

<script>
  import { safeHtml } from '@/helpers/vue-safehtml';
  export default {
    name: 'ftie-openai-chat',
    props: {
      prop_sfdc_page_obj: {
        default: null
      },
      prop_user_sites: {
        default: null
      },
      prop_user: {
        default: null
      },
      prop_request_detail_id: {
        default: null
      },
      prop_basic_info: {
        default: null
      },
    },
    data: function () {
      return {
        // openAI var region
        selectedGai: 'llama3.3:70b', //'gpt-3.5-turbo',
        hideOpenAiService: true,
        gaiOptions: [
          //{ value: 'gpt-3.5-turbo', text: 'gpt-3.5-turbo' },
          //{ value: 'lc-gpt-3.5-turbo', text: 'gpt-3.5-turbo (LangChain)' },
          //{ value: 'gpt-4o', text: 'gpt-4o', notEnabled: true },
          //{ value: 'lc-gpt-4o', text: 'gpt-4o (LangChain)' },
          //{ value: 'BreeXe-8x7B', text: 'BreeXe-8x7B (Traditional Chinese)' },
          { value: 'llama3.3:70b', text: 'llama3.3:70b (Getac On-premise AI)' },
          { value: 'deepseek-r1:70b', text: 'deepseek-r1:70b (Getac On-premise AI)' },
        ],

        langChainTaskOptions: [
          { value: null, text: 'Please select an option' },
          { value: 'translate', text: 'Language translate', disabled: true },
          {
            label: 'Summarize',
            options: [
              { value: 'lc_summarize_text', text: 'Summarize the text' },
              { value: 'lc_summarize_web', text: 'Summarize from web content' },
              { value: 'lc_summarize_doc', text: 'Summarize from uploading file', disabled: true },
              { value: 'lc_summarize_ticket', text: 'Summarize from ticket info', disabled: true }
            ]
          },
          {
            label: 'Comparison',
            options: [
              { value: 'lc_compare_web', text: 'Comparison between multiple web content', disabled: true },
              { value: 'lc_compare_doc', text: 'Comparison between multiple files', disabled: true },
              { value: 'lc_compare_ticket', text: 'Comparison between multiple tickets', disabled: true }
            ]
          },
        ],
        getacAiModelList: [],
        selectedLangChainTask: null,
        inputText: '',
        similarityResult: null, //Extension AI Service - Similarity
        upHere: false,
        chatGptOutput: '',
        chatGptPreviousOutput: '',//previous_response
        chatGptOutputModalId: '',
        titleText: "Hello, Getac on-premise AI is here to helping you ...",
        printerForOutputText: '',
        paper: '',
        paperOutput: '',
        timer: null,
        questionForChatGPT: '',
        followUpQuestionForChatGPT: '',
        enableManualType: false,
        storeConversation: false,
        hintToOpenManualType: "Function hasn't been activated, please switch to open this function",
        chosenPrompt: null,
        selectedLanguage: 'Traditional Chinese',
        languageOptions: [
          { text: 'English', value: 'English', disabled: true },
          { text: 'Traditional Chinese', value: 'Traditional Chinese' },
          { text: 'Simplified Chinese', value: 'Simplified Chinese' },
          { text: 'Japanese', value: 'Japanese' },
          { text: 'French', value: 'French' }
        ],
        // endregion


        isRouterAlive: true,
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        sfdcProducts: null,
        sfdcProductsOriginal: null,
        fixModel: true,
        fixCustomizationPn: "Customization",
        basicInfo: null,
        loginUser: null,
        userSites: null,
        actionEnable: false,
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        ftieId: encodeURIComponent(this.$route.params.ftie_id),
        createBy: null,
        realSkuNo: null,

        searching: false,
        maintianPnHint: '* Please maintain PN',
        noneSelectedHint: '',

        reloadBusy: false,
        processedIndex: [],

 
      }
    },

    watch: {
      paper: function () {
        if (this.paper.length == this.titleText.length) {
          this.paper = ''
        }
      },
      paperOutput: function () {
        if (this.paperOutput.length == this.printerForOutputText.length) {
          this.paperOutput = '';
          this.printerForOutputText = '';
          this.stoperOutput();
        }
      },
    },

    computed: {
      userFunctions() {
        return this.$session.get('user_functions');
      },
      userRoles() {
        return this.$session.get('user_roles');
      },


    },
    created() {
      let self = this;
      self.sfdcProducts = self.prop_sfdc_page_obj;
      self.sfdcProductsOriginal = self.prop_sfdc_page_obj;
      self.basicInfo = self.prop_basic_info;
      self.createBy = _.get(self.basicInfo, 'gtc_owner', null);
      self.userSites = self.prop_user_sites;
      self.loginUser = self.prop_user;
      self.request_detail_id = self.prop_request_detail_id;
      self.actionEnable = self.checkActionEnable();
      console.log(self.actionEnable);
      self.getGetacOnPremiseAiModels();
    },
    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
      },

      // Gen AI method regions
      showPromptResult(model, content, purpose, parameters, continuity) {
        let self = this;
        if (continuity) {
          self.chatGptPreviousOutput = self.chatGptOutput;
        }
        else {
          self.chatGptPreviousOutput = '';
        }
        self.chatGptOutput = '';
        self.chosenPrompt = purpose;
        self.printer();
        self.callChatGPTService(model, content, purpose, parameters, continuity);
        // purpose in ['hidden_meaning', 'translate', 'reply']
      },
      closePromptResult(subject_id) {
        let self = this;
        self.stoper();
        self.stoperOutput();
        self.cleanChatGPTPromptInput();
        self.enableManualType = false;
        self.selectedLanguage = 'Traditional Chinese';
        self.$bvModal.hide('modal-scrollable-' + subject_id)
      },

      cleanChatGPTPromptInput() {
        let self = this;
        self.chatGptOutput = '';
        self.chatGptPreviousOutput = '';
        self.printerForOutputText = '';
        self.chosenPrompt = '';
        self.storeConversation = false;
        //self.enableManualType = false;
        self.questionForChatGPT = '';
        self.followUpQuestionForChatGPT = '';
      },
      disableManualType(input_type) {
        let self = this;
        if ('follow-up' === input_type) {
          self.storeConversation = false
        } else {
          self.enableManualType = false;
        }
      },
      printerOutput() { // put start function herep
        this.stoperOutput();
        let i = -1;
        this.timer = setInterval(() => {
          if (i === -1) {
            this.paperOutput = ' ';
          }
          i++;
          if (i === 0) {
            this.paperOutput = '';
          }
          const x = i % this.printerForOutputText.length;
          this.paperOutput += this.printerForOutputText[x]
        }, 30)
      },

      stoperOutput() { // put stop functions here
        clearInterval(this.timer);
        this.paperOutput = ''
      },

      printer() { // put start function herep
        this.stoper();
        let i = -1;
        this.timer = setInterval(() => {
          i++
          const x = i % this.titleText.length
          this.paper += this.titleText[x]
        }, 200)
      },
      stoper() { // put stop functions here
        clearInterval(this.timer);
        this.paper = ''
      },


      // region Ticket Similarity
      callSimilarityService(content) {
        let self = this;
        let resultText = null;
        let url = self.$root.baseUrl + '/ai-service/similarity/';
        let request_data = {
          ftie_id: self.ftie_page_obj.ftie_id,
          content: content,
          sfdc_request_type: _.get(self.ftie_page_obj, 'category', null),
          es_description: _.get(self.ftie_page_obj, 'description', null),
          es_issue_req: _.get(self.ftie_page_obj, 'issue_req', null),
          device: _.get(self.ftie_page_obj, 'device', null),
          site: _.get(self.ftie_page_obj, 'site', null),
          vertical: _.get(self.ftie_page_obj, 'vertical', null)
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            console.log(res);
            if (response.status === 200) {
              resultText = res['similarity_response'];
            }
            else {
              // self.$message.exception('Internal Server Error!');
              resultText = null
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            self.similarityResult = resultText;
          })

      },
      // endregion
      getGetacOnPremiseAiModels() {
        let self = this;
        let url = self.$root.baseUrl + '/ai-service/getac-ai/model-list/'; // After H100 AI on-premise
        let request_data = {
          username: encodeURI(self.$store.state.username)
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            console.log(res);

            if (response.status === 200) {
              self.getacAiModelList = res['models'];
            }
            else {
              self.$message.exception('Internal Server Error!');
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            console.log('GETAC AI Models:');
            console.log(self.getacAiModelList);
            let model_list_option_new = new Array();
            if (self.getacAiModelList !== null && self.getacAiModelList.length > 0) {

              for (let i = 0; i < self.getacAiModelList.length; i++) {
                if (self.getacAiModelList[i] === 'llama3.3:latest') {
                  model_list_option_new.push({ value: 'llama3.3:70b', text: 'llama3.3:70b (Getac On-premise AI)' })
                } else {
                  let text_tmp = '' + self.getacAiModelList[i] + ' (Getac On-premise AI)';
                  model_list_option_new.push({ value: self.getacAiModelList[i], text: text_tmp })
                }
              }
              self.selectedGai = 'llama3.3:70b';
              self.gaiOptions = JSON.parse(JSON.stringify(model_list_option_new));
            } else {
              console.log("can not get supporting model from Getac AI Server");
              self.$message.exception('Can not get supporting model from Getac AI Server!');
            }
          })

      },

      // test chatGPT/getac AI
      callChatGPTService(model, content, purpose, parameters, continuity) {
        let self = this;
        let resultText = 'We’re sorry, we are unable to help you with that. Can you clarify the question again?';
        let reslutHtmlText = 'We’re sorry, we are unable to help you with that. Can you clarify the question again?';
        let resultTextPre = self.chatGptPreviousOutput;
        // let url = self.$root.baseUrl + '/ai-service/response/'; // Before H100 AI on-premise
        let url = self.$root.baseUrl + '/ai-service/getac-ai/response/'; // After H100 AI on-premise
        let request_data = {
          llm_model: model,
          content: content,
          purpose: purpose,
          parameters: parameters
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            console.log(res);

            if (response.status === 200) {
              resultText = res['chat_gpt_response'];
              resultTextPre = res['previous_response'];
              reslutHtmlText = res['html_response'];
            }
            else {
              self.$message.exception('Internal Server Error!');
              resultText = 'Getac AI can not answer this.'
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.stoper();
            self.stoperOutput();
            self.printerForOutputText = resultText;
            self.printerOutput();
            self.chatGptOutput = reslutHtmlText; //resultText
            self.chatGptPreviousOutput = reslutHtmlText; //previous_response
            self.storeConversation = false;
          })

      },
      showChatGPTResponseModal(input, comment_id, level_name) {
        let self = this;
        self.chatGptOutputModalId = '';
        let resultText = 'Testing...';
        let url = self.$root.baseUrl + '/ai-service/response/';
        self.chatGptOutputModalId = '' + level_name + '-' + comment_id;
        let request_data = {
          content: input,
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let save_success = false;
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            console.log(res);

            if (response.status === 200) {
              resultText = res['chat_gpt_response']
            }
            else {
              self.$message.exception('Internal Server Error!');
              resultText = 'ChatGPT can not answer this.'
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.$bvModal.hide('modal-chatgpt-' + level_name + '-' + comment_id);
            eventHub.$emit('loading', false);
            self.chatGptOutput = resultText;
            self.$bvModal.show('modal-chatgpt-' + level_name + '-' + comment_id);
          })
      },


      // endregion

      checkActionEnable() {
        let self = this;
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        if (self.loginUser === 'power') {
          return true;
        }

        // loginUser is gtc owner
        if (self.loginUser !== null && self.createBy !== null && self.loginUser === self.createBy) {
          return true;
        }
        if (self.userRoles !== null && _.size(self.userRoles) > 0) {
          if (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 || _.indexOf(self.userRoles, 'Admin') > -1 || _.indexOf(self.userRoles, 'ES_PM') > -1) {
            return true;
          }
        }
        if (self.userFunctions !== null && _.size(self.userFunctions) > 0) {
          if (_.indexOf(self.userFunctions, 'ES PM Leader') > -1 || _.indexOf(self.userFunctions, 'Tech Leader') > -1) {
            return true;
          }
        }
        //login_user_name === ftie_page_obj.gtc_owner || login_user_name === 'power' || (userRoles !== null && userRoles.includes('Admin')))
        return false;
      },
      /* ENDregion: TODO */
    }
  }
</script>
<style scoped>
   /* ========================================
  COMING SOON PAGE
  ======================================== */
   .coming-soon-page {
     min-height: 100vh;
     display: flex;
     align-items: center;
     justify-content: center;
     background: linear-gradient(135deg, #fdf6f0 0%, #f0f4f8 100%);
     padding: 2rem 1rem;
   }

   .coming-soon-card {
     background: #ffffff;
     border-radius: 20px;
     box-shadow: 0 12px 48px rgba(0, 0, 0, 0.10);
     padding: 3rem 2.5rem 2.5rem;
     max-width: 520px;
     width: 100%;
     text-align: center;
     border-top: 4px solid #f77530;
   }

   /* --- Icon area --- */
   .cs-icon-area {
     margin-bottom: 1.2rem;
   }

   .cs-icon-ring {
     width: 80px;
     height: 80px;
     border-radius: 50%;
     background: linear-gradient(135deg, #fff3ec, #ffe5d0);
     border: 2px solid rgba(247, 117, 48, 0.25);
     display: inline-flex;
     align-items: center;
     justify-content: center;
     margin-bottom: 0.4rem;
   }

   .cs-cog-icon {
     font-size: 2.2rem;
     color: #f77530;
     animation: cs-spin 6s linear infinite;
   }

   @keyframes cs-spin {
     from {
       transform: rotate(0deg);
     }

     to {
       transform: rotate(360deg);
     }
   }

   .cs-steam-row {
     display: flex;
     justify-content: center;
     gap: 8px;
   }

   .cs-steam {
     display: inline-block;
     width: 5px;
     height: 16px;
     background: #f77530;
     border-radius: 4px;
     opacity: 0;
     animation: cs-steam-rise 1.8s ease-in-out infinite;
   }

     .cs-steam:nth-child(2) {
       animation-delay: 0.35s;
     }

     .cs-steam:nth-child(3) {
       animation-delay: 0.7s;
     }

   @keyframes cs-steam-rise {
     0% {
       transform: translateY(0);
       opacity: 0;
     }

     40% {
       transform: translateY(-8px);
       opacity: 0.5;
     }

     100% {
       transform: translateY(-18px);
       opacity: 0;
     }
   }

   /* --- Brand badge --- */
   .cs-brand-badge {
     display: inline-flex;
     align-items: center;
     gap: 0.4rem;
     background: #f8f9fa;
     border: 1px solid #e9ecef;
     border-radius: 999px;
     padding: 0.3rem 0.9rem;
     margin-bottom: 1.2rem;
   }

   .cs-brand-logo {
     height: 16px;
     object-fit: contain;
   }

   .cs-brand-text {
     font-size: 0.72rem;
     font-weight: 600;
     color: #6c757d;
     letter-spacing: 0.03em;
   }

   /* --- Text --- */
   .cs-title {
     font-size: 1.5rem;
     font-weight: 700;
     color: #2d3748;
     margin-bottom: 0.75rem;
   }

   .cs-subtitle {
     font-size: 0.88rem;
     color: #718096;
     line-height: 1.7;
     margin-bottom: 1.6rem;
   }

   /* --- Progress bar --- */
   .cs-progress-wrap {
     margin-bottom: 1.6rem;
     text-align: left;
   }

   .cs-progress-label {
     font-size: 0.75rem;
     color: #888;
     font-weight: 600;
   }

   .cs-progress-pct {
     color: #f77530;
     font-weight: 700;
   }

   .cs-progress-track {
     height: 8px;
     background: #f0f0f0;
     border-radius: 999px;
     overflow: hidden;
   }

   .cs-progress-bar {
     height: 100%;
     width: 65%;
     background: linear-gradient(90deg, #f77530, #e05a10);
     border-radius: 999px;
     animation: cs-progress-pulse 3s ease-in-out infinite;
   }

   /*  ======================================== */
</style>



// WEBPACK FOOTER //
// src/components/framework-gen-ai/FTIEOpenAIChat.vue